/**
 * [Archies] Gift card recipient form — "I want to send this as a gift".
 *
 * Ported from Ella's recipient-form.js. Horizon 2.0.3 ships no recipient support.
 * Reference: https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards
 *
 * Two non-obvious behaviours, both inherited from Shopify's own implementation — do not
 * "simplify" them away:
 *
 *   1. The checkbox is rendered `disabled` and enabled HERE. The hidden `if_present` field is
 *      rendered enabled and disabled HERE. That inversion is the no-JS fallback: without this
 *      script the checkbox never submits and the hidden field tells Shopify to process whatever
 *      recipient fields were filled in.
 *
 *   2. Showing/hiding the fields is pure CSS (`:checked ~ .gc-recipient__fields`). This script
 *      never toggles visibility — it only clears values when the customer unticks, so a stale
 *      email can't be submitted after they change their mind.
 *
 * Not ported: Dawn's pub/sub subscriptions (cart-update / variant-change / cart-error). Horizon
 * has no equivalent bus, so cart-side errors surface through Horizon's own error handling and
 * server-rendered `form.errors` rather than being injected per-field.
 */

if (!customElements.get('gift-card-recipient-ext')) {
  customElements.define(
    'gift-card-recipient-ext',
    class GiftCardRecipientExt extends HTMLElement {
      connectedCallback() {
        const uid = this.dataset.uid;

        this.checkbox = this.querySelector(`#Recipient-Checkbox-${uid}`);
        this.control = this.querySelector(`#Recipient-Control-${uid}`);
        this.fields = [
          this.querySelector(`#Recipient-email-${uid}`),
          this.querySelector(`#Recipient-name-${uid}`),
          this.querySelector(`#Recipient-message-${uid}`),
          this.querySelector(`#Recipient-send-on-${uid}`),
        ].filter(Boolean);

        if (!this.checkbox) return;

        // Flip the no-JS defaults (see note 1 above).
        this.checkbox.disabled = false;
        if (this.control) this.control.disabled = true;

        this.errorWrapper = this.querySelector('.gc-recipient__errors');
        this.errorList = this.errorWrapper && this.errorWrapper.querySelector('.gc-recipient__errors-list');

        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange(event) {
        if (event.target !== this.checkbox) return;
        if (this.checkbox.checked) return;
        this.clearFields();
        this.clearErrors();
      }

      clearFields() {
        this.fields.forEach((field) => {
          field.value = '';
          field.removeAttribute('aria-invalid');
          field.removeAttribute('aria-describedby');
        });
      }

      clearErrors() {
        if (this.errorWrapper) this.errorWrapper.hidden = true;
        if (this.errorList) this.errorList.innerHTML = '';

        this.querySelectorAll('.gc-recipient__field-error').forEach((el) => {
          el.classList.add('hidden');
          const text = el.querySelector('.error-message');
          if (text) text.textContent = '';
        });
      }
    }
  );
}
